import { TransactionError } from '@editor/stores/paymentStore/types';
import { buildWebsiteUrl } from '@repo/utils/url';

import PaymentBlockedGraphic from './assets/PaymentBlockedGraphic/PaymentBlockedGraphic';
import PaymentFailedGraphic from './assets/PaymentFailedGraphic/PaymentFailedGraphic';
import PaymentPrePaidFailedGraphic from './assets/PaymentPrePaidFailedGraphic/PaymentPrePaidFailedGraphic';
import { titles } from './assets/titles';
import { cardError } from './card.errors';
import { paymentError } from './payment.error';
import { ContactSupportLink } from './styles';

export interface PaymentError {
  image: JSX.Element;
  isBlocked?: boolean;
  description: JSX.Element;
  title: string;
  supportUrl?: string;
  retryLabel: string;
}

export interface PaymentErrorInfo {
  title: string;
  description: string;
  supportUrl?: string;
}

const ContactSupport: React.FC = () => (
  <ContactSupportLink
    href={buildWebsiteUrl('/contact')}
    rel="noreferrer"
    target="_blank"
  >
    contact support
  </ContactSupportLink>
);

export const failedPaymentErrorData: (
  code: TransactionError['code']
) => PaymentError = (code) => {
  const error = cardError.get(code) ?? paymentError.get(code);
  const isPaymentError = paymentError.has(code);

  return {
    title: error?.title ?? titles.GENERIC_ERROR,
    retryLabel: 'Retry Payment',
    supportUrl: error?.supportUrl ? error.supportUrl : undefined,
    isBlocked: !isPaymentError,
    image: isPaymentError ? (
      <PaymentFailedGraphic />
    ) : (
      <PaymentBlockedGraphic />
    ),
    description: (
      <>
        {error?.description}
        {!error?.supportUrl && (
          <p>
            If you have any questions, please <ContactSupport />.
          </p>
        )}
      </>
    ),
  };
};

export const prepaidCardNotAllowedErrorData: PaymentError = {
  title: titles.CARD_PREPAID_NOT_ALLOWED,
  image: <PaymentPrePaidFailedGraphic />,
  retryLabel: 'Change payment method',
  description: (
    <>
      We accept credit cards, debit cards and PayPal.
      <br />
      Having hard times? Please <ContactSupport />.
    </>
  ),
};
